<div class="sidebar-wrapper"
     [class.mode-push]="isPushMode()"
     [class.mode-overlay]="!isPushMode()"
     [class.is-open]="isOpen()">

  <!-- Overlay Backdrop -->
  @if (!isPushMode() && isOpen()) {
    <button
      type="button"
      class="sidebar-backdrop"
      aria-label="Fechar menu"
      (click)="closeSidebar()"></button>
  }

  <aside class="sidebar-container shadow-4 flex flex-column surface-section">
    <!-- Header: Close Button & User Status -->
    <div class="sidebar-header flex flex-column surface-card relative z-1 border-bottom-1 surface-border">
      <!-- Close Button (Mobile Only) -->
      <div class="flex align-items-center justify-content-end px-3 py-2 lg:hidden">
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-times"
          class="p-button-rounded p-button-text p-button-secondary w-2rem h-2rem"
          (click)="closeSidebar()"
          aria-label="Fechar menu"></button>
      </div>

      <!-- User Profile Card (apenas identificação — navegação fica no item "Dados") -->
      @if (isLogged()) {
        <div class="sidebar-profile-wrap">
          <div class="sidebar-profile-card surface-50 border-round-xl border-1 surface-border flex align-items-center gap-3">
            <p-avatar [label]="formatUserName(user().name || '').charAt(0).toUpperCase()"
              size="large"
              styleClass="bg-primary-500 text-white shadow-1"
              shape="circle" />
            <div class="flex flex-column flex-1 min-w-0">
              <span class="text-900 font-semibold white-space-nowrap overflow-hidden text-overflow-ellipsis text-base capitalize">
                {{ formatUserName(user().name || '') }}
              </span>
              <span class="text-500 text-xs mt-1 white-space-nowrap overflow-hidden text-overflow-ellipsis">
                {{ user().email }}
              </span>
            </div>
          </div>
        </div>
      } @else {
        <!-- Guest State - Show Close Button -->
        <div class="px-3 py-2">
          <div class="text-center py-2">
            <i class="pi pi-lock text-4xl text-300 mb-2"></i>
            <p class="text-600 m-0 text-sm">Faça login para acessar</p>
          </div>
        </div>
      }
    </div>

    <!-- Scrollable Content -->
    <div class="sidebar-scroll flex-1 overflow-y-auto custom-scrollbar">
      <!-- Navigation Menu -->
      <nav class="sidebar-nav flex flex-column">
        @if (isLogged()) {
          @for (group of menuGroups(); track group.label) {
            <div class="sidebar-nav-group flex flex-column">
              @if (group.label) {
                <div class="sidebar-nav-heading text-xs font-bold text-500 uppercase letter-spacing-1 select-none">
                  {{ group.label }}
                </div>
              }

              <!-- Miolo compartilhado dos itens (button de ação × link de rota) -->
              <ng-template #navItemContent let-item>
                <div class="active-indicator absolute left-0 w-1 bg-primary-500 border-round-right opacity-0 transition-opacity"></div>

                <i [class]="item.icon" class="nav-icon"></i>
                <span class="nav-label text-sm font-medium">{{ item.label }}</span>

                @if (item.label !== 'Sair') {
                  <i class="pi pi-chevron-right sidebar-menu-arrow"></i>
                }
              </ng-template>

              <div class="sidebar-nav-items flex flex-column">
                @for (item of group.items; track item.label) {
                  <!-- Se tem command, usa button com click; se não, usa routerLink -->
                  @if (item.command) {
                    <button
                      type="button"
                      (click)="handleItemClick(item, false, $event)"
                      class="nav-item sidebar-nav-item border-round-lg cursor-pointer text-600 transition-colors transition-duration-200 select-none relative overflow-hidden"
                      pRipple
                      [class.text-red-500]="item.label === 'Sair'"
                      [class.hover:bg-red-50]="item.label === 'Sair'"
                      [class.mt-3]="item.label === 'Sair'"
                      [class.active-link]="isActiveRoute(item['activeRoute'])">
                      <ng-container [ngTemplateOutlet]="navItemContent" [ngTemplateOutletContext]="{ $implicit: item }" />
                    </button>
                  } @else {
                    <a
                      [routerLink]="item.routerLink"
                      [queryParams]="item.queryParams"
                      (click)="handleItemClick(item, true, $event)"
                      routerLinkActive="active-link"
                      [routerLinkActiveOptions]="item['exact']
                        ? {paths: 'exact', queryParams: item.queryParams ? 'exact' : 'ignored', fragment: 'ignored', matrixParams: 'ignored'}
                        : (item.queryParams ? {paths: 'subset', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored'} : {paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored'})"
                      class="nav-item sidebar-nav-item border-round-lg cursor-pointer text-600 transition-colors transition-duration-200 select-none relative overflow-hidden"
                      pRipple
                      [class.text-red-500]="item.label === 'Sair'"
                      [class.hover:bg-red-50]="item.label === 'Sair'"
                      [class.mt-3]="item.label === 'Sair'">
                      <ng-container [ngTemplateOutlet]="navItemContent" [ngTemplateOutletContext]="{ $implicit: item }" />
                    </a>
                  }
                }
              </div>
            </div>
          }
        } @else {
          <!-- Guest State - No menu items, just a message -->
          <div class="flex flex-column gap-3 mt-4 px-3">
            <div class="text-center py-4">
              <i class="pi pi-lock text-5xl text-300 mb-3"></i>
              <p class="text-600 m-0 text-sm mb-3">Faça login para acessar o menu completo</p>
              <button
                pButton
                label="Entrar ou Cadastrar"
                icon="pi pi-sign-in"
                class="w-full p-button-primary"
                (click)="openLoginModal($event)">
              </button>
            </div>
          </div>
        }
      </nav>
    </div>

    <!-- Footer -->
    <div class="sidebar-footer surface-section border-top-1 surface-border">
      @if (isLogged()) {
        <div class="flex flex-column gap-1 mb-2">
          <button
            type="button"
            class="nav-item sidebar-footer-action border-round-lg cursor-pointer transition-colors"
            pRipple
            (click)="logout()">
            <i class="pi pi-sign-out nav-icon"></i>
            <span class="nav-label text-sm font-medium">Sair</span>
          </button>
        </div>
      }

      <div class="flex flex-column align-items-center gap-2 sidebar-copyright">
        <span class="text-xs text-400 text-center line-height-3">
          &copy; {{ currentYear }} Seu Ingresso Aqui<br>
        </span>
      </div>
    </div>
  </aside>
</div>
